const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || "http://localhost:3376";

/**
 * @async
 * @description Fetches reviews from the backend API. Only returns a subset of reviews based on the page number to optimize performance.
 * @param {number} pageNumber The page number of reviews. This ensures we don't retrieve all reviews from Backend.
 * @param {number} pageSize The number of reviews to retrieve per page.
 * @param {Object} filters The filters to apply to the review retrieval.
 */
async function fetchGoogleReviews(pageNumber = 1, pageSize = 20, filters) {
  if (!pageNumber || typeof pageNumber !== "number" || pageNumber < 1) {
    throw new Error("Invalid page number. Page number must be a positive integer.");
  }

  else if (!pageSize || typeof pageSize !== "number" || pageSize < 1) {
    throw new Error("Invalid page size. Page size must be a positive integer.");
  }

  const url = new URL("/api/retrieve-reviews/google", API_BASE_URL);
  url.searchParams.append("pageNumber", pageNumber);
  url.searchParams.append("pageSize", pageSize);

  // Add filters if they exist
  let orderCriteria, orderDirection;
  if (filters?.orderCriteria) {
    orderCriteria = filters.orderCriteria;
  } else {
    orderCriteria = "updateTime"; // default order criteria
  }

  if (filters?.orderDirection) {
    orderDirection = filters.orderDirection;
  } else {
    orderDirection = "desc"; // default order direction
  }

  url.searchParams.append("orderCriteria", orderCriteria);
  url.searchParams.append("orderDirection", orderDirection);

  try {
    const res = await fetch(url.toString(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    const data = await res.json();
    if (res.ok) {
      return { success: true, reviews: data.reviews, totalReviews: data.totalReviews };
    } else {
      if (data.pageToBeFetched != null) {
        return { success: false, message: data.error || "Failed to fetch reviews.", pageToBeFetched: data.pageToBeFetched };
      }
      return { success: false, message: data.error || "Failed to fetch reviews." };
    }
  } catch (error) {
    console.error("Error fetching reviews:", error);
    return { success: false, message: data.error || "An error occurred while fetching reviews. Please try again." };
  }
}

export { fetchGoogleReviews };